const zeroDigitPrecisionCurrencyCodes = ['JPY', 'COP'];
export const getRoundingPrecision = currencyCode => zeroDigitPrecisionCurrencyCodes.includes(currencyCode) ? 0 : 2;
export const roundAmount = (amount, currencyCode) => {
  const roundingPrecision = getRoundingPrecision(currencyCode);
  const coefficient = Math.pow(10, roundingPrecision);
  if (amount < 0) {
    return -Math.round(-amount * coefficient) / coefficient;
  }
  return Math.round(amount * coefficient) / coefficient;
};